export const categories = [
  { slug: 'hanman', name: '韩漫', icon: 'ri-book-open-line', description: '韩国漫画精选，热门韩漫免费阅读', count: 128 },
  { slug: 'riman', name: '日漫', icon: 'ri-book-read-line', description: '日本漫画大全，经典日漫在线看', count: 256 },
  { slug: 'guoman', name: '国漫', icon: 'ri-book-2-line', description: '国产漫画精品，国漫崛起之作', count: 186 },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '热血战斗漫画，燃爆你的青春', count: 94 },
  { slug: 'aiqing', name: '爱情', icon: 'ri-heart-line', description: '甜蜜爱情漫画，心动就在此刻', count: 112 },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '悬疑推理漫画，烧脑不停歇', count: 67 },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '奇幻冒险漫画，精彩异世界之旅', count: 89 },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '搞笑欢乐漫画，笑到停不下来', count: 73 },
];

export const comics = [
  {
    id: 1,
    title: '剑与魔法之龙王传说',
    slug: 'sword-magic-dragon-king',
    author: '金泰亨',
    category: 'hanman',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20dragon%20warrior%20with%20sword%20and%20magical%20aura%2C%20epic%20fantasy%20art%2C%20dynamic%20pose%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20gold%20tones%2C%20manga%20cover%20style%20with%20clean%20simple%20background%2C%20detailed%20character%20design%2C%20professional%20illustration&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '少年龙战士在意外获得远古龙王的传承后，踏上了一场拯救世界的冒险之旅。面对强大的敌人和未知的挑战，他必须不断成长，揭开古老预言的真相。',
    status: '连载中',
    rating: 9.5,
    views: 1250000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: 8600 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2026-${String(8 - Math.floor(i / 30)).padStart(2, '0')}-${String(15 - (i % 30)).padStart(2, '0')}`,
    })),
    tags: ['奇幻', '冒险', '热血'],
  },
  {
    id: 2,
    title: '秘密花园之恋',
    slug: 'secret-garden-love',
    author: '朴美英',
    category: 'hanman',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20style%20illustration%20of%20a%20beautiful%20couple%20in%20a%20flower%20garden%2C%20soft%20romantic%20atmosphere%2C%20cherry%20blossoms%2C%20warm%20pastel%20pink%20and%20peach%20tones%2C%20shojo%20manga%20cover%20style%2C%20delicate%20art%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '平凡女孩意外进入贵族学校，与三位性格各异的校草展开了令人心跳加速的校园爱情故事。甜蜜、虐心、感动，一场关于青春与成长的爱恋。',
    status: '连载中',
    rating: 9.3,
    views: 980000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: 7200 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2026-${String(8 - Math.floor(i / 30)).padStart(2, '0')}-${String(20 - (i % 30)).padStart(2, '0')}`,
    })),
    tags: ['爱情', '校园', '逆袭'],
  },
  {
    id: 3,
    title: '暗夜追踪者',
    slug: 'night-tracker',
    author: '李哲洙',
    category: 'hanman',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20style%20illustration%20of%20a%20mysterious%20detective%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20dramatic%20shadows%20and%20warm%20street%20light%2C%20suspenseful%20mood%2C%20clean%20simple%20dark%20background%2C%20professional%20manhwa%20cover%20art&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '一名失去记忆的刑警，在追查连环案件的过程中，逐渐发现自己与案件有着千丝万缕的联系。真相背后隐藏着惊人的秘密。',
    status: '已完结',
    rating: 9.7,
    views: 2100000,
    updatedAt: '2026-07-15',
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: 4500 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2026-${String(7 - Math.floor(i / 15)).padStart(2, '0')}-${String(10 - (i % 15)).padStart(2, '0')}`,
    })),
    tags: ['悬疑', '推理', '犯罪'],
  },
  {
    id: 4,
    title: '妖神记',
    slug: 'demon-god-chronicles',
    author: '陈小凡',
    category: 'guoman',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20young%20cultivator%20with%20spiritual%20energy%20in%20ancient%20Chinese%20fantasy%20setting%2C%20flowing%20robes%2C%20magical%20glow%2C%20xianxia%20aesthetic%2C%20warm%20golden%20and%20red%20tones%2C%20clean%20simple%20background%2C%20professional%20manhua%20cover&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '少年聂离因妖灵之书重生回到年少时代，凭借前世记忆一路逆天改命，踏上了成为最强妖灵师的传奇之路。',
    status: '连载中',
    rating: 9.4,
    views: 1850000,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 112 }, (_, i) => ({
      id: 11200 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2026-${String(8 - Math.floor(i / 40)).padStart(2, '0')}-${String(25 - (i % 40)).padStart(2, '0')}`,
    })),
    tags: ['奇幻', '修仙', '热血'],
  },
  {
    id: 5,
    title: '都市之最强赘婿',
    slug: 'urban-strongest-son-in-law',
    author: '林动',
    category: 'guoman',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20urban%20manhua%20style%20illustration%20of%20a%20handsome%20businessman%20in%20modern%20city%20setting%2C%20confident%20expression%2C%20luxury%20lifestyle%20vibe%2C%20warm%20golden%20hour%20lighting%2C%20clean%20simple%20background%2C%20professional%20manhua%20cover%20art&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '他是豪门弃子，却隐姓埋名入赘寻常人家。三年后，当他亮出真实身份的那一刻，所有人都震惊了！一段逆袭人生的爽文漫画。',
    status: '连载中',
    rating: 9.1,
    views: 1560000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: 9800 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2026-${String(8 - Math.floor(i / 35)).padStart(2, '0')}-${String(18 - (i % 35)).padStart(2, '0')}`,
    })),
    tags: ['都市', '逆袭', '热血'],
  },
  {
    id: 6,
    title: '进击的巨人：自由之翼',
    slug: 'attack-on-titan-freedom-wings',
    author: '谏山创',
    category: 'riman',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20soldier%20with%20vertical%20maneuvering%20equipment%20flying%20through%20city%2C%20epic%20action%20scene%2C%20dramatic%20composition%2C%20warm%20sunset%20tones%20with%20dark%20shadows%2C%20professional%20manga%20cover%20style%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '在巨人的威胁下，人类被迫生活在巨大的城墙之内。少年艾伦目睹母亲被巨人吞噬后，发誓要消灭所有巨人，加入了调查兵团。',
    status: '已完结',
    rating: 9.8,
    views: 3500000,
    updatedAt: '2026-06-20',
    chapters: Array.from({ length: 139 }, (_, i) => ({
      id: 13900 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2023-${String(12 - Math.floor(i / 12)).padStart(2, '0')}-${String(10 - (i % 12)).padStart(2, '0')}`,
    })),
    tags: ['热血', '战斗', '末日'],
  },
  {
    id: 7,
    title: '鬼灭之刃：无限列车篇',
    slug: 'demon-slayer-mugen-train',
    author: '吾峠呼世晴',
    category: 'riman',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20demon%20slayer%20with%20katana%20and%20flame%20breathing%20effect%2C%20dynamic%20action%20pose%2C%20fire%20and%20water%20effects%2C%20traditional%20Japanese%20aesthetic%2C%20warm%20orange%20and%20red%20tones%2C%20clean%20simple%20background%2C%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '大正时代，少年炭治郎一家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹变回人类的方法，他踏上了成为鬼杀队剑士的道路。',
    status: '已完结',
    rating: 9.6,
    views: 2800000,
    updatedAt: '2026-05-10',
    chapters: Array.from({ length: 205 }, (_, i) => ({
      id: 20500 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2023-${String(12 - Math.floor(i / 18)).padStart(2, '0')}-${String(15 - (i % 18)).padStart(2, '0')}`,
    })),
    tags: ['热血', '战斗', '奇幻'],
  },
  {
    id: 8,
    title: '一人之下',
    slug: 'the-outcast',
    author: '米二',
    category: 'guoman',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20style%20illustration%20of%20a%20young%20man%20with%20mysterious%20power%20in%20modern%20Chinese%20setting%2C%20martial%20arts%20vibe%2C%20spiritual%20energy%20effects%2C%20warm%20amber%20and%20crimson%20tones%2C%20clean%20simple%20background%2C%20professional%20manhua%20cover&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '普通大学生张楚岚因爷爷的坟墓被盗而卷入了异人世界的纷争。在这个充满异能者的世界里，他逐渐揭开了自己身世的惊人秘密。',
    status: '连载中',
    rating: 9.5,
    views: 2200000,
    updatedAt: '2026-08-01',
    chapters: Array.from({ length: 168 }, (_, i) => ({
      id: 16800 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2025-${String(12 - Math.floor(i / 14)).padStart(2, '0')}-${String(20 - (i % 14)).padStart(2, '0')}`,
    })),
    tags: ['奇幻', '热血', '冒险'],
  },
  {
    id: 9,
    title: '我的女友是九尾狐',
    slug: 'my-girlfriend-is-a-nine-tailed-fox',
    author: '郑恩雅',
    category: 'hanman',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20style%20illustration%20of%20a%20beautiful%20nine-tailed%20fox%20spirit%20girl%20with%20modern%20boy%2C%20magical%20fox%20tails%2C%20mystical%20atmosphere%2C%20warm%20peach%20and%20gold%20tones%2C%20clean%20simple%20background%2C%20professional%20manhwa%20cover&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '普通大学生意外救下了一只受伤的九尾狐，没想到九尾狐化作人形后竟然要以身相许！人与妖之间的跨种族恋爱就此展开。',
    status: '已完结',
    rating: 9.4,
    views: 1680000,
    updatedAt: '2026-06-30',
    chapters: Array.from({ length: 60 }, (_, i) => ({
      id: 6000 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2025-${String(12 - Math.floor(i / 5)).padStart(2, '0')}-${String(15 - (i % 5)).padStart(2, '0')}`,
    })),
    tags: ['爱情', '奇幻', '校园'],
  },
  {
    id: 10,
    title: '咒术回战',
    slug: 'jujutsu-kaisen',
    author: '芥见下下',
    category: 'riman',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20supernatural%20manga%20style%20illustration%20of%20a%20jujutsu%20sorcerer%20with%20cursed%20energy%20effects%2C%20dark%20atmospheric%20mood%2C%20dynamic%20fighting%20stance%2C%20warm%20amber%20accents%20on%20dark%20background%2C%20clean%20simple%20composition%2C%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '高中生虎杖悠仁吞下诅咒之王的手指后，被迫卷入了咒术世界。在东京都立咒术高等专门学校，他将与伙伴们一起对抗诅咒。',
    status: '连载中',
    rating: 9.6,
    views: 3100000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 245 }, (_, i) => ({
      id: 24500 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2024-${String(12 - Math.floor(i / 21)).padStart(2, '0')}-${String(18 - (i % 21)).padStart(2, '0')}`,
    })),
    tags: ['热血', '战斗', '奇幻'],
  },
  {
    id: 11,
    title: '星梦偶像计划',
    slug: 'star-dream-idol-project',
    author: '苏小暖',
    category: 'guoman',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20idol%20manhua%20style%20illustration%20of%20a%20beautiful%20girl%20performing%20on%20stage%20with%20sparkling%20lights%2C%20pop%20star%20vibe%2C%20glamorous%20atmosphere%2C%20warm%20pink%20and%20gold%20stage%20lighting%2C%20clean%20simple%20background%2C%20professional%20manhua%20cover&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '普通女孩梦想成为顶流偶像，参加选秀节目后一路披荆斩棘。面对竞争、友情和爱情，她在追梦路上不断成长。',
    status: '连载中',
    rating: 9.0,
    views: 890000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 55 }, (_, i) => ({
      id: 5500 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2026-${String(8 - Math.floor(i / 20)).padStart(2, '0')}-${String(12 - (i % 20)).padStart(2, '0')}`,
    })),
    tags: ['励志', '爱情', '青春'],
  },
  {
    id: 12,
    title: '武林至尊',
    slug: 'martial-arts-supreme',
    author: '唐家三少',
    category: 'guoman',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20style%20illustration%20of%20a%20powerful%20warrior%20in%20ancient%20Chinese%20landscape%2C%20flowing%20martial%20arts%20pose%2C%20dramatic%20wind%20effects%2C%20warm%20golden%20sunset%20tones%2C%20clean%20simple%20background%2C%20professional%20manhua%20cover&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '落魄少年误入神秘古墓，获得绝世武功秘籍，从此踏上武林巅峰之路。江湖恩怨、儿女情长，一段快意恩仇的武侠传奇。',
    status: '连载中',
    rating: 9.2,
    views: 1340000,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 78 }, (_, i) => ({
      id: 7800 + i,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: `2026-${String(8 - Math.floor(i / 28)).padStart(2, '0')}-${String(22 - (i % 28)).padStart(2, '0')}`,
    })),
    tags: ['武侠', '热血', '冒险'],
  },
];

export const banners = [
  {
    id: 1,
    title: '剑与魔法之龙王传说 - 最新话更新！',
    comicId: 1,
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20illustration%20of%20a%20dragon%20warrior%20battling%20in%20a%20magical%20realm%2C%20dramatic%20composition%2C%20warm%20golden%20and%20orange%20lighting%2C%20cinematic%20atmosphere%2C%20detailed%20character%20art%2C%20fantasy%20landscape%20with%20mountains%20and%20castles%2C%20epic%20scale&width=1600&height=600&seq=banner-01&orientation=landscape',
  },
  {
    id: 2,
    title: '妖神记 - 全网独家首发连载',
    comicId: 4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20illustration%20of%20a%20cultivator%20flying%20through%20ancient%20Chinese%20mountains%2C%20spiritual%20energy%20flowing%2C%20dramatic%20clouds%20and%20mist%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%20composition%2C%20epic%20scale&width=1600&height=600&seq=banner-02&orientation=landscape',
  },
  {
    id: 3,
    title: '咒术回战 - 高潮决战篇开启',
    comicId: 10,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20supernatural%20action%20illustration%20with%20sorcerers%20fighting%20against%20dark%20curses%2C%20dramatic%20energy%20effects%2C%20urban%20Tokyo%20night%20setting%2C%20warm%20orange%20accents%20against%20dark%20atmosphere%2C%20cinematic%20composition%2C%20epic%20scale&width=1600&height=600&seq=banner-03&orientation=landscape',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20with%20warm%20smile%2C%20simple%20clean%20illustration%2C%20soft%20colors%2C%20minimal%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '妖精动漫真的是我见过最好的漫画网站！更新速度超快，画质也很清晰，每天必刷！',
    date: '2026-08-01',
  },
  {
    id: 2,
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20simple%20clean%20illustration%2C%20soft%20colors%2C%20minimal%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '韩漫资源太全了！在这里找到了好多小众但超好看的韩漫，强烈推荐给大家！',
    date: '2026-07-28',
  },
  {
    id: 3,
    name: '追更达人',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%20with%20glasses%2C%20simple%20clean%20illustration%2C%20soft%20colors%2C%20minimal%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '下拉式阅读体验太流畅了，比翻页舒服多了。每天晚上睡前都要看几话，根本停不下来。',
    date: '2026-07-25',
  },
  {
    id: 4,
    name: '资深漫迷',
    avatar: 'https://readdy.ai/api/search-image?query=Stylish%20anime%20style%20girl%20avatar%20with%20short%20hair%2C%20simple%20clean%20illustration%2C%20soft%20colors%2C%20minimal%20design&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '日漫国漫韩漫一站搞定，不用到处找了。分类也很清晰，找漫画超方便！',
    date: '2026-07-20',
  },
];

export const faqItems = [
  {
    question: '妖精动漫需要付费吗？',
    answer: '妖精动漫所有漫画内容完全免费阅读，无需任何付费。我们致力于为广大漫画爱好者提供优质的免费漫画阅读体验，让每个人都能畅享阅读的乐趣。',
  },
  {
    question: '妖精动漫支持哪些设备阅读？',
    answer: '妖精动漫完美支持电脑、平板和手机等所有设备。采用响应式设计，无论使用什么设备都能获得流畅舒适的阅读体验。推荐在手机上使用下拉式阅读模式，体验更佳。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '妖精动漫拥有专业的更新团队，热门漫画几乎做到与官方同步更新。韩漫通常在官方发布后24小时内更新，日漫和国漫也会在第一时间跟进，确保追更党不错过任何精彩内容。',
  },
  {
    question: '可以在妖精动漫上搜索特定漫画吗？',
    answer: '当然可以！妖精动漫提供强大的搜索功能，您可以通过漫画名称、作者名称或标签关键词快速找到想看的漫画。分类功能也可以帮您按类型浏览所有漫画。',
  },
  {
    question: '妖精动漫的漫画资源丰富吗？',
    answer: '妖精动漫汇集了海量优质漫画资源，涵盖韩漫、日漫、国漫三大板块，包括热血、爱情、悬疑、奇幻、搞笑等多种类型。目前站内共有数百部漫画，且每天都在不断上新。',
  },
];

export const aboutInfo = {
  brandName: '妖精动漫',
  founded: '2024年',
  mission: '让每个人都能免费享受漫画的乐趣',
  description: '妖精动漫成立于2024年，是国内领先的免费漫画在线阅读平台。我们致力于汇集全球优质漫画资源，包括韩国漫画、日本漫画和国产漫画，为广大漫画爱好者提供流畅、高清、免费的阅读体验。',
  story: '妖精动漫的创始团队由一群热爱二次元文化的年轻人组成。我们深知漫画迷在寻找优质阅读平台时遇到的困扰——资源分散、更新缓慢、阅读体验差。因此，我们决心打造一个集韩漫、日漫、国漫于一体的综合漫画阅读平台，让每一位漫画爱好者都能在这里找到心仪的作品，享受沉浸式的阅读乐趣。',
  values: [
    { title: '免费阅读', description: '所有漫画内容永久免费，让阅读零门槛', icon: 'ri-money-cny-circle-line' },
    { title: '海量资源', description: '韩漫、日漫、国漫全面覆盖，持续更新', icon: 'ri-stack-line' },
    { title: '极致体验', description: '下拉式流畅翻页，高清画质，沉浸阅读', icon: 'ri-smartphone-line' },
    { title: '快速更新', description: '热门漫画同步更新，追更不等待', icon: 'ri-flashlight-line' },
  ],
  stats: [
    { label: '漫画总数', value: '500+' },
    { label: '日活跃用户', value: '50万+' },
    { label: '累计阅读', value: '2亿+' },
    { label: '用户好评', value: '98%' },
  ],
  contact: {
    email: 'contact@yaojingdongman.com',
    wechat: '妖精动漫官方',
    weibo: '@妖精动漫',
    qq: '1234567890',
  },
};

export const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category' },
  { name: '关于我们', path: '/about' },
];